// extracted by mini-css-extract-plugin
export default {"container":"Navbar_container__xOq0V","GroupLink":"Navbar_GroupLink__mxXsJ","Link":"Navbar_Link__BKKY7"};